import axios from "axios";
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT + "/",
});

// axiosInstance.defaults.headers.common[
// "Authorization"
// ] = `auth ${localStorage.getItem("user-auth")}`;
// axiosInstance.defaults.headers.common["Accept"] = "application/json";
axiosInstance.interceptors.request.use((cfg) => {
  cfg.headers["Accept"] = "application/json";
  cfg.headers["Authorization"] = `auth ${localStorage.getItem("user-auth")}`;
  return cfg;
});

export default axiosInstance;
